<div class="flex flex-col justify-center items-center text-center">
  <div *ngFor="let clause of ksfPriceResult.clauses">
    <div class="font-syne font-semibold text-2xl tracking-tighter">
      {{ clause.name }}
    </div>

    <div class="my-10">
      <div class="font-syne text-sm text-[#1F2937]">
        <div *ngFor="let textLine of clause.textLines">
          {{ textLine }}
        </div>
      </div>
    </div>
  </div>

  <button
    *ngIf="!ksfPriceLoading"
    (click)="acceptClauses()"
    type="button"
    class="py-3 px-4 shadow-lg font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-teal-450 text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none w-auto"
  >
    Ok, forstået
  </button>
  <div class="m-5" *ngIf="ksfPriceLoading">
    <lib-loading-indicator size="10"></lib-loading-indicator>
  </div>
</div>
